/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { IonContent, IonModal } from "@ionic/react";

type Props = {
  dismissPressed: (...args: any) => any;
  visible: boolean;
};

const AuditTagErrorModal: React.FC<Props> = (props) => {
  return (
    <IonModal
      id="audit-tag-error-modal"
      isOpen={props.visible}
      backdropDismiss={true}
      canDismiss={true}
      onDidDismiss={() => props.dismissPressed()}
      className="fullscreen"
    >
      <IonContent>
        <div className="flex flex-col justify-between h-full">
          <div className="mt-4 px-4 flex flex-col justify-center">
            <div className="text-[20px] font-bold leading-default tracking-[-0.1px] text-center text-grey-90">
              {"Error"}
            </div>
            <div className="text-[15px] leading-[1.33] tracking-[-0.3px] text-center text-grey-90 mt-2">
              {"An error occurred when updating evidence"}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={props.dismissPressed}
              >
                <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-blue">
                  {"Dismiss"}
                </div>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default AuditTagErrorModal;
